import cx from 'classnames';
import React from 'react';
import { FormInputOption, toValue, useId, } from '../index.js';
export const FormInputOptionGroup = ({ children, className, layout, name, onChange, onOptionSelect, options, selected, showVisualCheckbox, type, variant, ...rest }) => {
    const uId = useId();
    const htmlName = name || uId;
    const htmlType = type || (Array.isArray(selected) ? 'checkbox' : 'radio');
    if (!children && (!options || !options.length)) {
        return null;
    }
    const handleChange = (e, option) => {
        if (onChange)
            onChange(e);
        if (onOptionSelect)
            onOptionSelect(e.target.value, option);
    };
    return (React.createElement("div", { className: cx('tds-form-input-group', {
            [`tds-form-input-group--layout-${layout}`]: layout,
        }, className), ...rest }, children ||
        (options === null || options === void 0 ? void 0 : options.map((option) => {
            const value = toValue(option);
            return (React.createElement(FormInputOption, { checked: selected
                    ? Array.isArray(selected)
                        ? selected.includes(value)
                        : selected === option.value
                    : undefined, key: String(value), name: htmlName, onChange: (e) => handleChange(e, option), showVisualCheckbox: showVisualCheckbox, type: htmlType, variant: variant, ...option, value: value }));
        }))));
};
